import styled from '@emotion/styled'
import { Grid, Typography } from '@mui/material'
import { PropertiesBuildingAndLot } from 'src/common-services'
import { GridPairKey, GridPairValue } from 'src/components/grid-pair'
import { Colors, Shapes } from 'src/components/theme'
import { prettyNumber } from 'src/utils/number-format'

const Wrapper = styled.div`
  padding-inline: ${Shapes.spacing[4]}px;
`

const Content = styled.div`
  display: flex;
  gap: ${Shapes.spacing[4]}px;
  padding: ${Shapes.spacing[4]}px;
  background-color: ${Colors.bgWhite};
  border-radius: ${Shapes.borderRadius}px;
  border: 1px solid ${Colors.border};
`
const SectionColumn = styled.div`
  width: 33%;
  border-right: 1px solid ${Colors.border};
  &:last-of-type {
    border-right: none;
  }
`
const SectionHeader = styled(Typography)`
  padding-bottom: ${Shapes.spacing[5]}px;
`

const SectionContent = styled(Grid)`
  .MuiGrid-item {
    padding-bottom: ${Shapes.spacing[4]}px;
  }
`

export const PropertyRecordsInfoBuildingLot = (props: { buildingAndLot: PropertiesBuildingAndLot }) => {
  const { buildingAndLot } = props
  const {
    yearBuilt,
    stories,
    numberOfBuildings,
    commercialUnits,
    lotAreaAcre,
    lotAreaSqFt,
    depth,
    frontage,
    propertyType,
    zoning,
    metropolitanStatisticalArea,
    county,
    municipality,
    neighborhood,
    legal,
  } = buildingAndLot

  return (
    <Wrapper>
      <Content>
        <SectionColumn>
          <SectionHeader variant="title2" color={Colors.textDark}>
            Building Details
          </SectionHeader>
          <SectionContent container>
            <GridPairKey>Year Built</GridPairKey>
            <GridPairValue>{yearBuilt}</GridPairValue>
            <GridPairKey># of Stories</GridPairKey>
            <GridPairValue>{stories}</GridPairValue>
            <GridPairKey># of Buildings</GridPairKey>
            <GridPairValue>{numberOfBuildings}</GridPairValue>
            <GridPairKey>Commerical Units</GridPairKey>
            <GridPairValue>{prettyNumber(commercialUnits)}</GridPairValue>
          </SectionContent>
        </SectionColumn>
        <SectionColumn>
          <SectionHeader variant="title2" color={Colors.textDark}>
            Lot Details
          </SectionHeader>
          <SectionContent container>
            <GridPairKey>Lot Sq. Footage</GridPairKey>
            <GridPairValue>{prettyNumber(lotAreaSqFt)}</GridPairValue>
            <GridPairKey>Lot Acreage</GridPairKey>
            <GridPairValue>{prettyNumber(lotAreaAcre)}</GridPairValue>
            <GridPairKey>Depth</GridPairKey>
            <GridPairValue>{prettyNumber(depth)}</GridPairValue>
            <GridPairKey>Frontage</GridPairKey>
            <GridPairValue>{prettyNumber(frontage)}</GridPairValue>
            <GridPairKey>Property Type</GridPairKey>
            <GridPairValue>{propertyType}</GridPairValue>
            <GridPairKey>Zoning</GridPairKey>
            <GridPairValue>{zoning}</GridPairValue>
          </SectionContent>
        </SectionColumn>
        <SectionColumn>
          <SectionHeader variant="title2" color={Colors.textDark}>
            Location Details
          </SectionHeader>
          <SectionContent container>
            <GridPairKey>MSA</GridPairKey>
            <GridPairValue>{metropolitanStatisticalArea}</GridPairValue>
            <GridPairKey>County</GridPairKey>
            <GridPairValue>{county}</GridPairValue>
            <GridPairKey>Municipality</GridPairKey>
            <GridPairValue>{municipality}</GridPairValue>
            <GridPairKey>Neighborhood</GridPairKey>
            <GridPairValue>{neighborhood}</GridPairValue>
            <GridPairKey>Legal Description</GridPairKey>
            <GridPairValue>{legal}</GridPairValue>
          </SectionContent>
        </SectionColumn>
      </Content>
    </Wrapper>
  )
}
